import BugsnagPerformance from '@bugsnag/browser-performance';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { APP_VERSION } from 'lib/constants';

// NewBugSnagClient starts a bug snag client
export default function BugSnagStart(){
    // Todo try catch
    if (!Bugsnag.isStarted()){
        const c = Bugsnag.start({
            apiKey:process.env.BUGSNAG_API_KEY!,
            plugins: [new BugsnagPluginReact()],
            appVersion: APP_VERSION, 
            releaseStage: process.env.SITE_NAME, // eg. sb1, sb2, prod
            metadata:{}
        })
        BugsnagPerformance.start({ apiKey: process.env.BUGSNAG_API_KEY! })
        console.log(`\n------------\n[bugsnag]\t🐞 Started bug snag successfully!!!\n------------\n\n`)
    } else {
        console.log(`\n------------\n[bugsnag]\t🪲 Already started!!!\n------------\n\n`)
    }
}
